import React from 'react';

import { leaveBreadcrumb } from 'Utils';

import About from 'Routing/About';
import ExportView from 'Routing/ExportView';

import Header from 'Components/Header';
import Footer from 'Components/Footer';
import Intro from 'Components/Intro';
import Map from 'Components/Map';

// AdminPanel is dev-only. Wrapping the require in a NODE_ENV check lets
// webpack's DefinePlugin tree-shake the entire AdminPanel module out of
// production bundles (QA / Prod / nonprod), so it's neither rendered nor shipped.
const AdminPanel = process.env.NODE_ENV === 'development'
    ? require('Components/AdminPanel').default
    : null;

function Routing() {
    leaveBreadcrumb('Routing initiated.');

    return (
        <>
            <Header />
            <About />
            <Intro />
            <ExportView />
            <Map />
            <Footer />
            {AdminPanel && <AdminPanel />}
        </>
    );
}

export default Routing;
